import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../_components/common/Navbar';
import SideNavBar from '../../../_components/common/SideNavBar'
import { orgAdminAreaData } from '../OrgAdminArea/SidebarData'
import './index.css'
import UtilityNav from '../../../_components/common/UtilityNav';
import TableNew from '../../../_components/common/Table';
import ModalComponent from '../../../_components/common/Modal';
import { Input } from 'reactstrap';
import { paUserPermissions, teamName } from './formData';
import { orgAdminAction } from '../../../_actions';
import AccessData from '../../../_components/common/AccessData';


class PaUsersPermissions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            allowAccess: false,
            denyAccess: false,
            toggleAnalysis: false,
            orgId: null,
            updateModalState: false,
            updateMessage: null,
            userDetails: null,
            paUserId: 'null',
            paUserName: null,
            selectedTeams: '',
            checkBoxData: [],
            buttonData: [],
            teams: [],
            navData: [],
            tableData: [

            ]
        }
    }

    componentDidMount() {
        this.setState({
            orgId: +this.props.match.params.id
        })

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }

        this.setState({navData: temp})
        this.props.dispatch(orgAdminAction.getOrgUsersHandler(+this.props.match.params.id, () => {
            this.props.dispatch(orgAdminAction.getOrgTeamHandler(+this.props.match.params.id, () => {
                let pathName = this.props.location.pathname.split('/');
                if (pathName[pathName.length - 1] === 'PaUsersPermissions' && this.props.getOrgUsersResponse.length > 0) {
                    const fd = {
                        "pa_user_email": this.props.getOrgUsersResponse.length > 0 ? this.props.getOrgUsersResponse[0].pa_user__email : '',
                        "analytic_organisation_id": +this.props.match.params.id,
                        // "user_id": this.props.getOrgUsersResponse[0].id
                    }
                    this.props.dispatch(orgAdminAction.getPaUserPermissionListHandler(fd, () => { }))
                    const queryParams = [];
                    queryParams.push(encodeURIComponent('user') + '=' + encodeURIComponent(this.props.getOrgUsersResponse[0].id))
                    const queryString = queryParams.join('&');
                    this.props.history.push({
                        search: '?' + queryString
                    });
                    this.setState({
                        paUserName: this.props.getOrgUsersResponse[0].pa_user__email,
                    })
                }
                if (pathName[pathName.length - 1] !== 'PaUsersPermissions') {
                    this.props.getOrgUsersResponse.map(
                        (data, i) => {
                            if (+pathName[pathName.length - 1] === data.id) {
                                this.setState({
                                    paUserName: data.pa_user__email,
                                    paUserId: pathName[pathName.length - 1]
                                }, () => {
                                    const fd = {
                                        "pa_user_email": data.pa_user__email,
                                        "analytic_organisation_id": +this.props.match.params.id,
                                    }
                                    this.props.dispatch(orgAdminAction.getPaUserPermissionListHandler(fd, () => { }))
                                })
                            }
                        }
                    )
                }

            }))
        }))
        this.setState({
            buttonData: [
                {
                    id: 1,
                    name: 'Allow Access',
                    toggler: this.toggleAllowAccessModal.bind(this),
                    togglerModal: this.state.allowAccess,
                    disabled: 'disabled',
                    title: 'Allow Access',
                    icon: 'fa fa-plus',
                },
                {
                    id: 2,
                    name: 'Deny Access',
                    toggler: this.toggleDenyAccessModal.bind(this),
                    togglerModal: this.state.denyAccess,
                    disabled: 'disabled',
                    title: 'Deny Access',
                    icon: 'fa fa-minus',
                }
            ]
        })
    }

    componentDidUpdate(prevProps, prevState) {

        if(prevProps.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }

        if ((prevProps.getPaUserPermissionListResponse !== this.props.getPaUserPermissionListResponse)) {
            if (this.props.getPaUserPermissionListResponse !== '' && this.props.getOrgTeamsResponse !== '' && this.props.getOrgTeamsResponse !== undefined) {
                let tempData = this.getReformatData(this.props.getOrgTeamsResponse, this.props.getPaUserPermissionListResponse)
                if (this.props.getPaUserPermissionListResponse !== '' && this.props.getOrgTeamsResponse !== '') {
                    this.setState({
                        tableData: tempData
                    })
                }
            }
        }
    }

    toggleAllowAccessModal(showModal) {
        this.setState({
            allowAccess: showModal
        })
    }

    toggleDenyAccessModal(showModal) {
        this.setState({
            denyAccess: showModal
        })
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    toggleEntireUserPermissionsModal(showModal) {
        this.setState({
            allowAccess: showModal,
            denyAccess: showModal,
            toggleAnalysis: showModal,
        })
    }

    onChangeTeam = (ev) => {
        const paUserName = this.props.getOrgUsersResponse.filter(
            (data, i) => {
                if (data.id === +ev.target.value) {
                    return data
                }
            }
        )[0].pa_user__email
        this.setState({
            paUserName: paUserName,
            paUserId: ev.target.value
        })
        this.props.history.replace(`/organisation/${this.props.match.params.id}/org-admin/PaUsersPermissions`);
        const queryParams = [];
        queryParams.push(encodeURIComponent('user') + '=' + encodeURIComponent(ev.target.value))
        const queryString = queryParams.join('&');
        this.props.history.push({
            search: '?' + queryString
        });

        const fd = {
            "pa_user_email": paUserName,
            "analytic_organisation_id": +this.state.orgId,
            // "user_id": ev.target.value
        }
        this.props.dispatch(orgAdminAction.getPaUserPermissionListHandler(fd, () => { }))
    }

    getSelectedData = (data) => {

        if (data.length !== 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, true)
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, false)
            })
        }
    }

    selectAllAssessment(data, clickToggle) {
        const { buttonData } = this.state;
        clickToggle === true ?
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = ''
                    this.setState({
                        reRenderSettingsHead: 2,
                        assessmentResponse: data
                    })
                }
            })
            :
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled'
                    this.setState({
                        reRenderSettingsHead: 1,
                        assessmentResponse: data
                    })
                }
            })
    }

    getChildrenData = (childrenData, tempData) => {
        for (let j = 0; j < childrenData.length; j++) {
            if (childrenData[j] !== null && childrenData[j].children.length > 0) {
                tempData.push({
                    ...childrenData[j],
                    'buttonDisabled': childrenData[j].is_parent,
                    'rowCheck': true,
                    'access': ' fa fa-times text-danger',
                })
                this.getChildrenData(childrenData[j].children, tempData)
            }
            if (childrenData[j] !== null && childrenData[j].children.length == 0) {
                tempData.push({
                    ...childrenData[j],
                    'buttonDisabled': childrenData[j].is_parent,
                    'rowCheck': true,
                    'access': ' fa fa-times text-danger',
                })
            }
        }
    }

    getReformatData = (tableData, getPaUserPermissionListResponse) => {

        const additionalData = {
            'rowCheck': true,
            'access': ' fa fa-times text-danger',
        }
        let tempData = [];
        for (let i = 0; i < tableData.length; i++) {
            if (tableData[i].children.length > 0) {
                tempData.push({
                    ...tableData[i],
                    'buttonDisabled': tableData[i].is_parent,
                    'rowCheck': true,
                    'access': ' fa fa-times text-danger',
                })
                this.getChildrenData(tableData[i].children, tempData)
            }
            if (tableData[i].children.length === 0) {
                tempData.push({
                    ...tableData[i],
                    'buttonDisabled': tableData[i].is_parent,
                    'rowCheck': true,
                    'access': ' fa fa-times text-danger',
                })
            }
        }

        tempData.map(
            (data, i) => {
                for (let i = 0; i < getPaUserPermissionListResponse.length; i++) {
                    if (data.id === getPaUserPermissionListResponse[i].analytics_team_id) {
                        data.access = ' fa fa-check text-success'
                    }
                }
            }
        )
        return tempData
    }

    enableAddOrRemove = (checkBoxData, type) => {
        let count = 0;
        for (let i = 0; i < checkBoxData.length; i++) {

            if (checkBoxData[i].access === (type === 'add' ? ' fa fa-check text-success' : ' fa fa-times text-danger')) {


                count = count + 1;
            }
        }
        return count === checkBoxData.length ? false : true;
    }

    actionSelectedDenyAccess = (type) => {
        this.setState({
            denyAccess: false
        })
    }

    actionSelectedAccess = (type) => {
        if (type === 'Add' || type === 'Remove') {
            const teamId = [];
            const { checkBoxData } = this.state;
            for (let i = 0; i < checkBoxData.length; i++) {
                if (type === 'Add') {
                    if (checkBoxData[i].access === ' fa fa-times text-danger') {
                        teamId.push(checkBoxData[i].id)
                    }
                }
                if (type === 'Remove') {
                    if (checkBoxData[i].access === ' fa fa-check text-success') {
                        teamId.push(checkBoxData[i].id)
                    }
                }
            }
            const fd = {
                'organisation_team_id_list': teamId,
                'pa_user_email': this.state.paUserName
            }
            this.props.dispatch(orgAdminAction.changeAccessPaUsersHandler(fd, type, (data) => {
                const fd = {
                    "pa_user_email": this.state.paUserName,
                    "analytic_organisation_id": +this.state.orgId,
                    // "user_id": ev.target.value
                }
                this.setState({
                    updateMessage: {
                        status: data.status,
                        text: `<div className = " text-center">
                        <p className = "font-weight-bold">${(data.status === 200 || data.status === 201) ? 'Success!' : 'Error!'}</p>
                        <p> ${data.data.message[0].message}.</p>
                    </div>`,
                        heading: 'MANAGE PA USER PERMISSIONS',
                        headerColor: (data.status === 200 || data.status === 201) ? `` : `bg-danger`,
                        headingIcon: (data.status === 200 || data.status === 201) ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                    },
                    updateModalState: true
                })
                this.props.dispatch(orgAdminAction.getPaUserPermissionListHandler(fd, () => { }))
            }))
        }
        this.setState({
            allowAccess: false,
            denyAccess: false
        })
    }

    getAccessModalData = (checkBoxData) => {
        const headings = [{
            'name': 'Team Name',
            'textCenter': false
        }, {
            'name': 'Access',
            'textCenter': true

        }]
        const keyNames = [{
            'name': 'team_name'
        }]
        return AccessData(checkBoxData, headings, keyNames)
    }

    render() {
        const { getOrgUsersResponse, getOrgUsersLoading, getOrgTeamsResponse, getPaUserPermissionListResponse, getPaUserPermissionListLoading } = this.props;
        const tables = {
            Team: [{
                name: 'Organisation',
                key: 'team_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                level: 'team_level',
                link: '',
                rowCheck: 'rowCheck'
            },

            {
                name: 'Access',
                key: 'EDIT',
                link: '',
                sort: false,
                type: 'icon',
                content: 'access',
                alignCenter: true,
                headingAlign: true,
                buttonDisabled: 'buttonDisabled',
                link: ''

            },
            ]
        }

        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={orgAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">MANAGE PA USER PERMISSIONS</h5>
                        <div className="d-flex flex-row justify-content-center">
                            <span className="col- my-1 mb-0 " > Choose PA User: &nbsp;
                                	{/* {
                                    getOrgUsersLoading &&
                                    <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                } */}
                            </span>

                            <Input
                                value={this.state.paUserId}
                                type="select" name="field"
                                bsSize="sm" className="col-2 border-1"
                                onChange={this.onChangeTeam}
                            >
                                {
                                    getOrgUsersResponse !== '' &&
                                    getOrgUsersResponse.map(
                                        (data, i) => {
                                            return <option className="" value={data.id} key={i}>{data.pa_user__email}</option>
                                        }
                                    )
                                }
                            </Input>
                            {
                                (getOrgUsersResponse !== '' && getOrgUsersResponse.length === 0) &&
                                <span className="text-center text-danger font-weight-bold my-1 mb-0">&nbsp;*Please Add PA user</span>
                            }
                        </div>

                        <UtilityNav
                            actionButtons={this.state.buttonData}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />
                        {
                            (getPaUserPermissionListResponse !== '' && getOrgUsersResponse !== '' && getOrgTeamsResponse !== '' && getOrgUsersResponse.length > 0) &&
                            <TableNew
                                data={this.state.tableData.length === 0 ? this.getReformatData(getOrgTeamsResponse, getPaUserPermissionListResponse) : this.state.tableData}
                                columns={tables.Team}
                                checkbox="true"
                                selectCheckBox={this.selectAllAssessment.bind(this)}
                                getData={this.getSelectedData.bind(this)}
                                CheckKey={"id"}
                            />
                        }
                        {/* {
                            (getPaUserPermissionListResponse === '' || getOrgUsersResponse === '' || getOrgTeamsResponse === '') &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                &nbsp;Loading</p>
                        } */}

                        {
                            this.state.allowAccess &&
                            <ModalComponent
                                showModal={this.state.allowAccess}
                                heading="Allow Access"
                                // formData={paUserPermissions}
                                // action={this.actionSelectedAccess.bind(this)}
                                htmlTag={this.getAccessModalData(this.state.checkBoxData)}
                                toggleEntireModal={this.toggleEntireUserPermissionsModal.bind(this)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData, 'add') ? [{
                                    'buttonName': 'Add',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                selectKey={['permission_id']}
                                selects={['permission_name']}
                                responseHandler={(type) => this.actionSelectedAccess(type)}

                            />
                        }

                        {
                            this.state.denyAccess &&
                            <ModalComponent
                                showModal={this.state.denyAccess}
                                heading="Deny Access"
                                // formData={paUserPermissions}
                                // action={this.actionSelectedDenyAccess.bind(this)}
                                htmlTag={this.getAccessModalData(this.state.checkBoxData)}
                                toggleEntireModal={this.toggleEntireUserPermissionsModal.bind(this)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData, 'remove') ? [{
                                    'buttonName': 'Remove',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                selectKey={['permission_id']}
                                selects={['permission_name']}
                                responseHandler={(type) => this.actionSelectedAccess(type)}
                            />
                        }

                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false })}
                            />
                        }
                    </div>
                </ div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { getOrgUsersLoading } = state.getOrgUsers;
    const getOrgUsersError = state.getOrgUsers.error;
    const getOrgUsersResponse = (!getOrgUsersLoading && !getOrgUsersError) ? state.getOrgUsers.data.data.organisation_PA_users : '';

    const { getOrgTeamsLoading } = state.getOrgTeams;
    const getOrgTeamsError = state.getOrgTeams.error;
    const getOrgTeamsResponse = (!getOrgTeamsLoading && !getOrgTeamsError) ? state.getOrgTeams.data.data.team_list : '';

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    return {
        getOrgUsersLoading,
        getOrgUsersResponse,
        getOrgTeamsResponse,
        getPaUserPermissionListLoading,
        getPaUserPermissionListResponse,
    headPerLoadingResonse,
    headPerLoading,
    headPerLoadingError
    }
}

export default connect(mapStateToProps)(PaUsersPermissions);


// WEBPACK FOOTER //
// ./src/_pages/Organzation/OrgAdminArea/PaUsersPermissions.js